import { cn } from 'cn';
import { NavLink } from 'react-router';

/** The five persona homes in fixed order; never counts (docs/ux/shell.md). */
export const HOMES = [
  { to: '/pipeline', label: 'Pipeline' },
  { to: '/qa', label: 'QA' },
  { to: '/dr', label: 'Doctors' },
  { to: '/clinic', label: 'Clinic' },
  { to: '/registry', label: 'Registry' },
] as const;

export function PersonaNav({ className }: { className?: string }) {
  return (
    <nav aria-label="Persona homes" className={cn('flex h-full items-stretch gap-5', className)}>
      {HOMES.map((h) => (
        <NavLink
          key={h.to}
          to={h.to}
          className={({ isActive }) =>
            cn(
              'relative flex items-center text-sm font-medium no-underline transition-colors duration-[140ms] ease-beam',
              // On the ink bar the signature is expressed as harbour, the same
              // substitution DESIGN.md makes for the on-ink focus ring.
              'after:absolute after:inset-x-0 after:bottom-0 after:h-0.5 after:bg-beam-harbour after:opacity-0 after:transition-opacity after:duration-[140ms]',
              isActive ? 'text-beam-cream after:opacity-100' : 'text-beam-on-ink-muted hover:text-beam-cream',
            )
          }
        >
          {h.label}
        </NavLink>
      ))}
    </nav>
  );
}
